import { type MCPServerInfo } from '../../types';

const LucidServer: MCPServerInfo = {
  serverId: 'LUCID',
  name: 'Lucid',
  slug: 'lucid',
  description:
    'Official Lucid remote MCP server. Search Lucidchart diagrams and Lucidspark boards, summarize documents, create shareable links, and generate diagrams from datasets or descriptions.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.lucid.app/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default LucidServer;
